<template>
  <MglMarker :coordinates="coordinates" anchor="bottom">
    <div slot="marker">
      <MapPin style="transform: scale(3)" />
      <StatusDot :fillColor="statusColor" />
    </div>
    <MglPopup :offset="48" :closeButton="false" @open="onOpen">
      <IndividualHospitalPopup
        :dataset="dataset"
        :resource="resource"
        :isOpen="isPopupOpen"
      />
    </MglPopup>
  </MglMarker>
</template>

<script>
import IndividualHospitalPopup from '@/components/HospitalMap/individual-hospital-popup';
import MapPin from '@/assets/map-pin.svg';
import StatusDot from '@/components/status-dot';
import centerMapOnPopup from '@/util/centerMapOnPopup';
import { AggregateChartColors } from '@/store/types';
import { MglMarker, MglPopup } from 'vue-mapbox';

export default {
  components: {
    IndividualHospitalPopup,
    MapPin,
    MglMarker,
    MglPopup,
    StatusDot,
  },
  props: {
    dataset: {
      type: Object,
      required: true,
    },
    resource: {
      type: String,
      required: true,
    },
  },
  data() {
    return { isPopupOpen: false };
  },
  computed: {
    coordinates() {
      return [this.dataset.location.lng, this.dataset.location.lat];
    },
    statusColor() {
      const [status] = Object.entries(this.dataset[this.resource]).find(
        ([, value]) => value,
      );
      return status
        ? AggregateChartColors[status.toUpperCase()]
        : AggregateChartColors.NO_DATA;
    },
  },
  methods: {
    onOpen(event) {
      this.isPopupOpen = true;
      const { map, popup } = event;
      centerMapOnPopup(map, popup);
    },
  },
};
</script>

<style scoped>
.status-dot {
  position: absolute;
  left: 8px;
  top: -16px;
}
</style>
